import React from 'react';
import './Home.css'; // Assurez-vous de créer ce fichier CSS
import 'animate.css/animate.min.css'; // Import global de l’animation
import profileImage from '../images/Moi.jpg'; // Remplacez par le chemin de votre photo
import resumeFile from '../images/Abdelbassit_CV.pdf';

function Home() {
  return (
    <section id="home" className="d-flex align-items-center justify-content-center">
      <div className="container">
        <div className="row">
          {/* Colonne pour la photo */}
          <div className="col-lg-6 d-flex justify-content-center">
            <img
              src={profileImage}
              alt="Profile"
              className="profile-image img-fluid rounded-circle animate__animated animate__fadeInLeft"
            />
          </div>
          {/* Colonne pour le texte */}
          <div className="col-lg-6 d-flex flex-column justify-content-center align-items-start text-section">
            <h2 className="animate__animated animate__fadeInRight">Hello, I'm Abdelbassit MAHAMADENE FACHIR</h2>
            <p className="animate__animated animate__fadeInRight">
                        A DevOps Engineer specialized in cloud computing and cybersecurity...            </p>
            {/* Buttons */}
            <div className="mt-4">
              <a href="#contact" className="btn btn-primary btn-lg me-3 animate__animated animate__fadeInUp">Hire Me</a>
              <a href={resumeFile} className="btn btn-secondary btn-lg animate__animated animate__fadeInUp">Get Resume</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
